import React from 'react';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const features = [
    {
      icon: 'Code2',
      title: 'Complete Project Generation',
      description: 'Generate full-stack applications with organized folder structures, including frontend components, backend APIs, and database schemas in a single click.',
      color: 'text-blue-500'
    },
    {
      icon: 'Package',
      title: 'Downloadable ZIP Files',
      description: 'Receive your entire project as a ready-to-use ZIP package with all dependencies, configurations, and documentation included for immediate deployment.',
      color: 'text-emerald-500'
    },
    {
      icon: 'Sparkles',
      title: 'Production-Ready Code',
      description: 'Get clean, maintainable code following industry best practices with proper error handling, security implementations, and scalable architecture patterns.',
      color: 'text-purple-500'
    },
    {
      icon: 'Database',
      title: 'Database Schema Generation',
      description: 'Automatically generate optimized database schemas with migrations, relationships, and indexes tailored to your application requirements.',
      color: 'text-amber-500'
    },
    {
      icon: 'Shield',
      title: 'Built-in Authentication',
      description: 'Every project includes secure authentication boilerplate with user registration, login, password reset, and session management out of the box.',
      color: 'text-red-500'
    },
    {
      icon: 'Zap',
      title: 'Lightning Fast Generation',
      description: 'Advanced AI processes your requirements and generates complete projects in under 30 seconds, saving hours of manual setup and configuration time.',
      color: 'text-cyan-500'
    }
  ];

  return (
    <section className="py-12 md:py-20 lg:py-28 bg-background">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-10 md:mb-14 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            Everything You Need to Build Faster
          </h2>
          <p className="text-sm md:text-base lg:text-lg text-muted-foreground max-w-2xl mx-auto">
            Our AI-powered platform handles the heavy lifting so you can focus on what matters—building great products.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10">
          {features?.map((feature, index) => (
            <div
              key={index}
              className="group bg-card border border-border rounded-xl p-6 md:p-7 lg:p-8 hover:border-primary/50 transition-all duration-300 hover:shadow-lg hover:shadow-primary/10 hover:-translate-y-1"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-lg bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center mb-4 md:mb-5 lg:mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <Icon name={feature?.icon} size={24} className={feature?.color} />
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-2 md:mb-3 lg:mb-4">
                {feature?.title}
              </h3>
              <p className="text-sm md:text-base lg:text-lg text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;